import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { Button, Icon, Title, Field, Control } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useDirections } from "../../utils/hooks";

import "./PrintDirections.scss";

import { FormattedDirections } from "../Directions";

import { printDirections } from "../../utils/export";
import { ourToast as toast } from "../../utils";

const PrintDirections = ({
  start,
  pickup,
  delivery,
  ending,
  onComplete = () => {}
}) => {
  const [state, setState] = useState({});

  const { directions: startToPickup } = useDirections(start, pickup);
  const { directions: pickupToDelivery } = useDirections(pickup, delivery);
  const { directions: deliveryToEnding } = useDirections(delivery, ending);

  useEffect(() => {
    if (startToPickup && startToPickup !== state.startToPickup) {
      setState(prevState => ({ ...prevState, startToPickup }));
    }
    if (pickupToDelivery && pickupToDelivery !== state.pickupToDelivery) {
      setState(prevState => ({ ...prevState, pickupToDelivery }));
    }
    if (deliveryToEnding && deliveryToEnding !== state.deliveryToEnding) {
      setState(prevState => ({ ...prevState, deliveryToEnding }));
    }
  }, [
    startToPickup,
    pickupToDelivery,
    deliveryToEnding,
    state.startToPickup,
    state.pickupToDelivery,
    state.deliveryToEnding
  ]);

  const handlePrint = name => () => {
    const rawDirections = state[name];
    printDirections(rawDirections[0]);
  };

  const printEm = (...args) => {
    const errors = [];

    const directions = args.reduce((acc, curr) => {
      const result = state[curr.value][0];
      if (!result) {
        errors.push(curr);
      } else {
        acc.push(result);
      }
      return acc;
    }, []);
    if (errors.length) {
      errors.forEach(err => {
        toast.error(`No directions found for ${err.label}`);
      });
    }

    printDirections(...directions);
  };

  const handlePrintAll = () => {
    printEm(
      { value: "startToPickup", label: "Start Location to Pickup Location" },
      {
        value: "pickupToDelivery",
        label: "Pickup Location to Delivery Location"
      },
      {
        value: "deliveryToEnding",
        label: "Delivery Location to Ending Location"
      }
    );
  };

  return (
    <div className="print-directions">
      <div className="print-directions-header">
        <Title marginless>Print Directions</Title>
        <Field kind="group">
          <Control>
            <Button onClick={handlePrintAll}>
              <Icon>
                <FontAwesomeIcon icon="print" />
              </Icon>
              <span>Print All</span>
            </Button>
          </Control>
          <Control>
            <Button color="link" onClick={onComplete}>
              Close
            </Button>
          </Control>
        </Field>
      </div>

      <div className="print-directions-body">
        <FormattedDirections
          end={pickup}
          handlePrint={handlePrint("startToPickup")}
          start={start}
          type="Start to Pickup"
        />
        <FormattedDirections
          end={delivery}
          handlePrint={handlePrint("pickupToDelivery")}
          start={pickup}
          type="Pickup to Delivery"
        />
        <FormattedDirections
          end={ending}
          handlePrint={handlePrint("deliveryToEnding")}
          start={delivery}
          type="Delivery to Ending"
        />
      </div>
    </div>
  );
};

PrintDirections.propTypes = {
  start: PropTypes.number,
  pickup: PropTypes.number,
  delivery: PropTypes.number,
  ending: PropTypes.number,
  onComplete: PropTypes.func
};
export default PrintDirections;
